import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import { CalendarRangeControlModule } from '@ui/form/calendar-range-control/calendar-range-control.module';
import { ApiB2BListB2BLoadGet$Params } from '@api/fn/b-2-b/api-b-2-b-list-b-2-b-load-get';
import { ButtonModule } from '@ui/form/button/button.module';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { convertDateTimeToDbFormat } from '@core/localization/local-date-adapter.helpers';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * B2b download history filter
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-uploads-filter',
    templateUrl: './uploads-filter.component.html',
    styleUrls: ['./uploads-filter.component.scss'],
    imports: [ReactiveFormsModule, CalendarRangeControlModule, ButtonModule, TranslatePipe],
})
export class UploadsFilterComponent implements OnInit {
    /**
     * Server pending flag
     */
    @Input() public pending: boolean;
    /**
     * B2b program id
     */
    @Input() public prgId: number;
    /**
     * Submit form event
     *
     * @returns Form data
     */
    @Output() public submitForm: EventEmitter<ApiB2BListB2BLoadGet$Params> = new EventEmitter<ApiB2BListB2BLoadGet$Params>();

    readonly #fb: FormBuilder = inject(FormBuilder);
    readonly #dateAdapter: LocalDateAdapter = inject(LocalDateAdapter);

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;

    /**
     * Date format
     */
    public readonly calendarFormat: string = this.#dateAdapter.format.bsDatePicker;

    /**
     * Current date value
     */
    public readonly currentDate: Date = new Date();

    /**
     * Date from filter value
     */
    public readonly defaultStartDate: Date = new Date(new Date().setMonth(this.currentDate.getMonth() - 1));

    /**
     * Date to filter value
     */
    public readonly defaultEndDate: Date = new Date(this.currentDate.setHours(23, 59, 59));

    public readonly form: FormGroup = new FormGroup({
        date: this.#fb.control([this.defaultStartDate, this.defaultEndDate], [Validators.required]),
    });

    public get date(): AbstractControl {
        return this.form.get('date');
    }

    public ngOnInit(): void {
        setTimeout(() => this.handlerSubmit());
    }

    public handlerSubmit(): void {
        const outputDate: Date[] = this.date.value;

        this.submitForm.emit({
            prgId: this.prgId,
            dateFrom: convertDateTimeToDbFormat(outputDate[0]),
            dateTo: convertDateTimeToDbFormat(outputDate[1]),
        });
    }
}
